<template>
  <div>
    <!-- 导航 -->
    <el-breadcrumb>
      <el-breadcrumb-item>
        <router-link to="/">首页</router-link>
      </el-breadcrumb-item>
      <el-breadcrumb-item>问答管理</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 搜索 -->
    <div class="content">
      <el-form
        inline
        :model="query"
        label-position="right"
        label-width="60px"
        size="small"
        class="query-form"
        @submit.native.prevent="getList()"
      >
        <el-form-item label="搜索">
          <el-input v-model="query.key" placeholder="请输入关键词"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="selClick()">查询</el-button>
          <el-button type="success" @click="dialogVisible=true;form={isEnable:true};">新增</el-button>
        </el-form-item>
      </el-form>

      <!-- 主体 -->
      <el-card class="box-card table">
        <div class="clearfix" slot="header">
          <span>问答列表</span>
        </div>

        <!-- 列表 -->
        <el-table
          v-loading="loading"
          :data="tableData"
          ref="tableData"
          border
          stripe
          style="width:100%"
          @sort-change="sortChange"
          @filter-change="filterTag"
        >
          <el-table-column label="标题">
              <template slot-scope="scope">
                  <a :href="scope.row.url" target="_blank">{{scope.row.title}}</a>
              </template>
          </el-table-column>
          <el-table-column prop="viewCount" label="浏览次数"></el-table-column>
          <el-table-column prop="createTime" label="添加时间"></el-table-column>

          <!-- 操作 -->
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button-group>
                <el-tooltip content="编辑" placement="top">
                  <el-button
                    type="primary"
                    size="small"
                    icon="el-icon-edit"
                    @click="editClick(scope.row)"
                  ></el-button>
                </el-tooltip>
                <el-tooltip content="删除" placement="top">
                  <el-button
                    type="warning"
                    size="small"
                    icon="el-icon-delete"
                    @click="delClick(scope.row)"
                  ></el-button>
                </el-tooltip>
              </el-button-group>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="block" style="margin-top:20px;">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage4"
            :page-size="pageSize"
            :page-sizes="[10,20,30,50,100]"
            layout="total,sizes,prev,pager,next,jumper"
            :total="total"
          ></el-pagination>
        </div>
      </el-card>
    </div>

    <!-- 弹框 -->
    <el-dialog :title="form.id>0?'编辑问答':'添加问答'" :visible.sync="dialogVisible">
      <el-form
        :model="form"
        ref="form"
        label-width="100px"
        :status-icon="true"
        @submit.native.prevent="submitForm(form)"
      >
        <el-form-item prop="title" label="问答标题" :rules="[{required:true,message:'不能为空'},{max:30,min:1,message:'最长30个字'}]">
          <el-input v-model="form.title" placeholder="请输入问答标题"></el-input>
        </el-form-item>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item prop="schID" label="关联学校">
              <el-select v-model="form.schID" filterable remote clearable placeholder="请选择学校">
                <el-option
                  v-for="item in schlist"
                  :label="item.name"
                  :key="item.id"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item prop="content" label="回答内容" :rules="[{required:true,message:'不能为空'}]">
          <div style="position:relative;">
            <vue-ueditor-wrap v-model="form.content" :config="editorConfig"></vue-ueditor-wrap>
          </div>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" :loading="submiting" native-type="submit">提交</el-button>
          <el-button @click="dialogVisible=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import VueUeditorWrap from "vue-ueditor-wrap";
import url from "@/plugins/urlHelper.js";
export default {
  data() {
    return {
      query: {},
      form: {},
      dialogVisible: false,
      loading: false,
      submiting: false,
      tableData: [],
      total: 0,
      pageSize: 10,
      currentPage4: 1,
      content: "",
      editorConfig: {
        zIndex: 3000, //配置控件组件弹出层
        initialFrameHeight: 300, //设置高度
        initialFrameWidth: "100%", //设置宽度
        UEDITOR_HOME_URL: url.getUEConfig(),
        serverUrl: url.getUE()
      },
      schlist: []
    };
  },
  methods: {
    handleSizeChange: function(val) {
      this.pageSize = val;
      this.currentPage4 = 1;
      this.getList();
    },
    handleCurrentChange: function(val) {
      this.currentPage4 = val;
      this.getList();
    },
    // 排序
    sortChange: function(sortColumn) {
      this.query.sortColumn.sort;
      this.query.order = sortColumn.order;
      this.getList();
    },
    // 筛选
    filterTag: function(filter) {
      var val = filter["isEnable"][0];
      this.getList();
    },
    // 关联学校
    getSchList: function() {
      var _this = this;
      var link = url.getCommon("getschollall");
      $.get(link, {}, data => {
        _this.schlist = data;
      });
    },
    // 列表
    getList: function() {
      var _this = this;
      _this.loading = true;
      var params = _this.query;
      params.pageSize = _this.pageSize;
      params.pageIndex = _this.currentPage4;
      var link = url.getVideo("getlist_question");
      $.get(link, params, data => {
        _this.loading = false;
        _this.tableData = data.list;
        _this.total = data.total;
      });
    },
    // 查询
    selClick: function() {
      this.currentPage4 = 1;
      this.getList();
    },
    // 编辑
    editClick: function(row) {
      var _this = this;
      _this.dialogVisible = true;
      var id = row.id;
      var link = url.getVideo("getmodel_question");
      $.get(link, { id: id }, data => {
        _this.form = data;
      });
    },
    // 删除
    delClick: function(row) {
      var _this = this;
      var id = row.id;
      var link = url.getVideo("delete_question");

      this.$confirm("确定要删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          $.post(link, { id: id }, res => {
            if (res.status) {
              _this.dialogVisible = false;
              _this.getList();
              _this.$message({
                type: "success",
                message: res.msg
              });
            } else {
              _this.$message({
                type: "error",
                message: res.msg
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    // 提交
    submitForm: function(formName) {
      var _this = this;
      var link = url.getVideo("save_question");
      var info = this.form;

      this.$refs.form.validate(valid => {
        if (valid) {
          _this.submiting = true;

          // 提交后台  添加或修改
          $.post(link, info, res => {
            _this.submiting = false;
            if (res.status) {
              _this.dialogVisible = false;
              _this.getList();
              _this.$message({
                type: "success",
                message: res.msg
              });
            } else {
              _this.$message({
                type: "error",
                message: res.msg
              });
            }
          });
        } else {
          return;
        }
      });
    }
  },
  components: {
    VueUeditorWrap
  },
  mounted() {
    // 关联学校
    this.getSchList();
    // 列表
    this.getList();
  }
};
</script>